import { HttpTimeoutPriority } from 'utils/enums/http-timeout-priority';

import {
  ICreateFareRequest,
  ICreateFareResponse,
  IUpdateFareRequest,
  IUpdateFareResponse,
  IGetSingleFareResponse,
  IGetFaresResponse,
  IDeleteFaresResponse,
  IDeleteFaresFilters,
  IGetFaresFilters,
} from 'models/http/fares';
import { prepareFiltersOfSelection, prepareQPFromFilters, serverAxios } from '../../http';
import { AxiosResponse } from 'axios';
import { HTTP } from './core.http';
import DataUploadBaseHttp from './utils/data-upload.http';
import { DataUploadModels, ModelsNames } from 'utils/enums/model-names';
import { IGetSimpleListFilters, IGetSimpleListResponse } from 'models/http/common';

class FaresHttp extends DataUploadBaseHttp implements HTTP<IDeleteFaresFilters> {
  protected readonly route: DataUploadModels = ModelsNames.Fares;

  public async getSimple(_?: IGetSimpleListFilters, abortController?: AbortController): Promise<IGetSimpleListResponse> {
    return serverAxios
      .get(`/${this.route}/simple`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetSimpleListResponse>) => {
        return response.data;
      });
  }

  public async getById(id: string, abortController?: AbortController): Promise<IGetSingleFareResponse> {
    return serverAxios
      .get(`/${this.route}/single/${id}`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetSingleFareResponse>) => {
        return response.data;
      });
  }

  public async get(filters?: IGetFaresFilters, abortController?: AbortController): Promise<IGetFaresResponse['records']> {
    const queryParams = prepareQPFromFilters(filters || {});

    return serverAxios
      .get(`/${this.route}?${queryParams.toString()}`, {
        timeout: HttpTimeoutPriority.Medium,
        signal: abortController?.signal,
      })
      .then((response: AxiosResponse<IGetFaresResponse>) => {
        return response.data.records;
      });
  }

  public async create(data: ICreateFareRequest): Promise<ICreateFareResponse> {
    return serverAxios
      .post(`/${this.route}`, data, {
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<ICreateFareResponse>) => {
        return response.data;
      });
  }

  public async update(id: number, data: IUpdateFareRequest): Promise<IUpdateFareResponse> {
    return serverAxios
      .put(`/${this.route}/${id}`, data, {
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IUpdateFareResponse>) => {
        return response.data;
      });
  }

  public async delete(ids: number[]): Promise<IDeleteFaresResponse>;
  public async delete(filters: IDeleteFaresFilters): Promise<IDeleteFaresResponse>;
  public async delete(filters: number[] | IDeleteFaresFilters): Promise<IDeleteFaresFilters> {
    return serverAxios
      .delete(`/${this.route}`, {
        data: prepareFiltersOfSelection(filters),
      })
      .then((response: AxiosResponse<IDeleteFaresFilters>) => {
        return response.data;
      });
  }
}

export default FaresHttp;
